/* eslint-disable */
import firebase from 'firebase';
import CONSTANT from '../Constant';
import Utils from '../Utils';
import db from '../firebaseInit'
import firebaseConfig from '../firebaseConfig'

// const firebaseApp = firebase.initializeApp(firebaseConfig)

// eslint-disable
export default class UserService {

    constructor(){
        db.firestore.settings({ timestampsInSnapshots: true });
    }
    
    // READ

    static getMembers( { locations = "", sortBy = "" } ) {
        const users = db.collection(CONSTANT.COLLECTIONS.USERS);
        let members = users;
        // let members = users.where('role', '==', 'member');
        //   members.where('role', '==', 'basic');
        //  members.where('role', '==', 'pro');
        if (locations) {
            members = members.where('city', '==', locations);
        }
        if (sortBy) {
            members = members.orderBy(sortBy, 'asc');
        }
        return members.get();
    }
    
    static firebaseSignInWithEmailAndPassword(user) {
        return new Promise((resolve) => {
            if (user) {

                firebase.auth().signInWithEmailAndPassword(user.email, user.password)
                .then((firebaseUser) => {
                    firebase.auth().onAuthStateChanged((firebaseUserNew) => {
                        resolve(firebaseUser);
                    });
                })
                .catch((error) => {
                    // Error Handling
                    resolve(error);
                });
            } else {
                resolve(null);
            }
        })
    }

    static createUserWithEmailAndPassword(user) {
        return new Promise((resolve) => {
            if (user) {

                firebase.auth().createUserWithEmailAndPassword(user.email, user.password)
                .then((firebaseUser) => {
                    firebase.auth().onAuthStateChanged((firebaseUserNew) => {
                        resolve(firebaseUser);
                    });
                })
                .catch((error) => {
                    // Error Handling
                    resolve(error);
                });
            } else {
                resolve(null);
            }
        })
    }
    
    static loginUser(user) {
        if (user) {
            return new Promise((resolve) => {
                db.collection(CONSTANT.COLLECTIONS.USERS).where('email', '==', user.email).limit(1).get().then((dbUser) => {
                    if (!dbUser.empty) {
                        dbUser.forEach((doc) => {
                            var _user = doc.data();
                            var _decryptPassword = Utils.decryptString(_user.password, _user.userId);
                            
                            if(user.password == _decryptPassword){
                                var _obj = {
                                    userId: _user.userId,
                                    email: _user.email
                                };
                                resolve(_obj);
                            } else {
                                resolve(0);
                            }
                        })
                    } else {
                        console.log("User Not Found!");
                        resolve(null);
                    }
                })
            })
        } else {
            resolve(null);
        }
    }

    static getUserById(id, resolve) {
        if (id) {
            return new Promise((resolve) => {
                db.collection(CONSTANT.COLLECTIONS.USERS).doc(id).get().then((doc) => {
                    if (doc.exists) {
                        resolve(doc.data());
                    } else {
                        console.log("No such document!");
                        resolve(null);
                    }
                })
            })
        } else {
            return new Promise((resolve) => {
                resolve(null);
            });    
        }
    }
    
    static getCurrentFirebaseUser(resolve) {
        return new Promise((resolve) => {
            console.log("No such document!");
            resolve(firebase.auth().currentUser);
        })
    }

    static getUserByEmail(email, resolve) {
        if (email) {
            return new Promise((resolve) => {
                db.collection(CONSTANT.COLLECTIONS.USERS).where('email', '==', email).limit(1).get().then((users) => {
                    if (!users.empty) {
                        users.forEach((doc) => {
                            var _user = doc.data();
                            resolve(_user);
                        })
                    } else {
                        console.log("No such document!");
                        resolve(0);
                    }
                })
            })
        } else {
            return new Promise((resolve) => {
                resolve(null);
            });    
        }
    }

    // ADD, UPDATE, DELETE

    static addNewUser(user, UUID) {
        var _USER = Object.assign({}, user);
        
        return new Promise((resolve) => {
            db.collection(CONSTANT.COLLECTIONS.USERS).doc(UUID).set(_USER)
                .then(docRef => {
                    console.log('User added : ', docRef)
                    resolve(docRef);
                })
                .catch(function (error) {
                    console.error('Error adding user: ', error)
                });
        });
    }
    
    static firebaseSignOut() {
        
        return new Promise((resolve) => {
            firebase.auth().signOut().then((user) => {
                // Sign-out successful.
                resolve(user);
            }).catch((error) => {
                // An error happened.
                resolve(error);
            });
        });

    }

    static saveUserProfile(user) {
        var _USER = Object.assign({}, user);
        
        return new Promise((resolve) => {
            firebase.auth().currentUser.updateEmail(_USER.email).then((user) => {
                firebase.auth().currentUser.updatePassword(_USER.password).then((user) => {
                    // 
                    // var encryptPwd = Utils.encryptString(_USER.password, _USER.userId);
                    // _USER.password = encryptPwd;

                    delete _USER["password"];
                    delete _USER["cpassword"];
                    
                    db.collection(CONSTANT.COLLECTIONS.USERS).doc(_USER.userId).set(_USER)
                        .then(docRef => {
                            console.log('User profile updated : ', docRef)
                            resolve(docRef);
                            // resolve(user);
                        })
                        .catch(function (error) {
                            console.error('Error updating user profile: ', error);
                            resolve(error);
                        });
                }).catch((err) => {
                    resolve(err);
                });
            }).catch((err) => {
                //Do something
                resolve(err);
            });
        });

    }
}
